import React from "react";
import circle from '../../assets/img/circulogris.png';
import Button from "../../utils/components/Button/Button";
import Options from "../../utils/components/Options/Options";
import { changeReportAdminZones } from '../../admin/actions/reportActions'
import { useHistory } from "react-router-dom";
import audio from '../../assets/img/audio.png';
import play from '../../img/ic_play.png'
import "./CardList.css";

import { Translate } from "../../language";
import { useDispatch } from "react-redux";
import useModal from "../../utils/hooks/useModal";

const CartListReport = ({
  descriptions, typeOfReportsIDS,
  options = [],
  post,
  comment,
  picture = '',
  textOne,
  textTwo,
  content,
  key = '',
  type,
  _id,
  onClick = () => { }
}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [refModal, isShowModal, setIsShowModal] = useModal()

  return (
    <div key={_id} className="content-card-list-zone_report">
      <div className="options-card-list-zone_report">
        <Options style={{ zIndex: 1,position:"inherit" }} options={options} />
      </div>
      {/* <Options options={options} /> */}
      {
       ( type ==="zonemember" || type ==="entity" ) && (
          <div className="content-img-card_report" onClick={onClick}>
            <div className="row">
          <div>
          {textOne}
          </div>
            <img alt="img" className="img-content-card-list-zone" onError={(e) => e.target.src = circle} src={picture}></img>
           
            </div>
         
          </div>
        )
      }
      {(type ==="zonepost" || type ==="post") &&
        < div className="content_post_card_report">
          {renderPost(post)}
        </div>
      }
      {type ==="comment" &&
        < div className="content_post_card_report">
          {comment.text}
        </div>
      }

      <div className="content-name-card-list-zone scroll-menu" onClick={onClick}>
        <div className="content-text-card-list-zone">
    
          <div className="text-two-card-list-zone">
            <Button onClick={() => {
              setIsShowModal(true)

            }} classNameContent="text-two-card-list-zone" theme="white" text={"Ver motivos de reporte"} />
          </div>
          <Modal
            isShow={isShowModal}
            close={() => setIsShowModal(false)}
            descriptions={descriptions}
            typeOfReportsIDS={typeOfReportsIDS}
          />
        </div>
      </div>
    </div >
  );
};

const Modal = ({ isShow, close, descriptions, typeOfReportsIDS }) => {
  const divStyle = {
    display: isShow ? 'block' : 'none'
  };
  return (
    <div style={divStyle}
      className="modal">
      <div className="modal-content modal-report-post" >
        {
          descriptions.map(description => (
            <div>{description.message}</div>
          ))
        }
      </div>
    </div>
  )
}
const renderPost = (data, isHover, options, style) => {
  var viewData

  // data.userId && data.userId.picture && data.userId.picture.url && data.userId.picture.url.origin

  const user = data.userId ? {
    name: data.userId.name,
    lastname: data.userId.lastname,
    picture: data.userId && data.userId.picture && data.userId.picture.url && data.userId.picture.url.origin
  } : data.franchiseID ? {
    name: data.franchiseID.socialReason,
    lastname: "",
    picture: data.franchiseID && data.franchiseID.picture && data.franchiseID.picture.url && data.franchiseID.picture.url.origin
  } :
    data.representativeID ? {
      name: data.representativeID.userID.name,
      lastname: data.representativeID.userID.lastname,
      picture: data.representativeID.userID && data.representativeID.userID.picture && data.representativeID.userID.picture.url && data.representativeID.userID.picture.url.origin
    } : {
      name: "",
      lastname: ""
    }

  const w = style?.gridColumn?.trim().replace(/\s+/g, '_')
  const shared = style?.share ===true ? true : false
  if (data && data.multimedia && data.multimedia.type) {

    if (data.multimedia?.type.includes('image'))
      viewData =
        <div className={`img-post-masory-card`}>

          <img
            onError={(e) => {
              e.target.src = (data.multimedia.url && data.multimedia.url.medium ? data.multimedia.url.medium : data.multimedia.url.origin) + "#"
            }}

            className='img-post-masory-card' src={data.multimedia.url && data.multimedia.url.medium ? data.multimedia.url.medium : data.multimedia.url.origin} alt="" />
        </div>

    if (data.multimedia?.type.includes('video'))
      viewData =
        <div className="img-post-masory-card">
          {/* <video preload="none" autoPlay={false} className="video-post-view" controls poster={data.multimedia.url.thumbnail}>
                      <source src={data.multimedia.url ? data.multimedia.url.medium : data.multimedia.url.origin}></source>
                  </video> */}

          <div className="content-icon-play-video">
            <img alt="img" className="img-video-post" src={play}></img>
          </div>
          <img alt="img"

            className="img-post-masory-card" src={data.multimedia.url.thumbnail}></img>
        </div>
    // if (data.multimedia?.type.includes('video/hls'))
    //     viewData =
    //         <VideoImp autoPlay={false} playbackUrl={data.multimedia.url.origin} />
    if (data.multimedia.type.includes('audio'))
      viewData =
        <div className='img-post-masory-card'>

          <img className='audio-post-masory-card' src={audio} alt="" />
        </div>

    return (
      viewData
    )
  } else
    return (
      <div className={`${shared ? "" : "text-post-masory-card"} img-post-masory-card`}>


        <div className='text-post-masory-card-contend'>
          {data.description ? data.description.substr(0, true ? 500 : 500) + '...' : '...'}
        </div>

      </div>)
}
export default CartListReport;

